import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { ROUTE_DATA_PATH } from '../../../../config/paths';
import { ROUTE_DATA_COLUMNS } from '../../../../config/columns';
import {
  clearRoutesData,
  getRoutesData,
} from '../../../../actions/route/routeData';

export const RoutesData = ({
  breadcrumbs,
  routesData,
  loading,
  dispatchGetRoutesData,
  dispatchClearRoutesData,
}) => {
  useLayoutEffect(() => () => dispatchClearRoutesData(), []);

  const data = routesData.get('content') || [];
  const pages = routesData.get('totalPages') || null;
  const defaultPageSize = routesData.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Lista de Exportaciones de Rutas"
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: ROUTE_DATA_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetRoutesData,
        modelPath: ROUTE_DATA_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetRoutesData: getRoutesData,
  dispatchClearRoutesData: clearRoutesData,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Exportaciones de Rutas',
      href: ROUTE_DATA_PATH,
    },
  ],
  routesData: RouteUnit.RouteData.getIn(['all', 'content']),
  loading: RouteUnit.RouteData.getIn(['all', 'loading']),
});

RoutesData.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  routesData: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetRoutesData: PropTypes.func.isRequired,
  dispatchClearRoutesData: PropTypes.func.isRequired,
};

RoutesData.defaultProps = {
  routesData: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoutesData);
